import React from "react";
import { observer } from "mobx-react";
import SimilarArticle from "./SimilarArticle";

const Similar = observer(
  ({ articles, addArticleToPlaylist, selectArticle, trackingId }) => {
    return (
      <>
        <div className="header">
          <span>Playing Next</span>
        </div>
        {/* <div>
          {articles.map((article) => (
            <SimilarArticle
              key={article.article_id}
              {...{
                article,
                trackingId,
                addArticleToPlaylist,
                selectArticle
              }}
            />
          ))}
        </div> */}
      </>
    );
  }
);

export default Similar;
